<template>
  <el-carousel :interval="5000" arrow="always" :height="bannerHight+'px'">
    <el-carousel-item v-for="(item,index) in homeBannerList" :key="index">
      <div :class="{ bn_hand:item.active===1 }" @click="homeBannerLink(item)">
        <img :src="item.path" alt="" height="500" width="100%">
      </div>
    </el-carousel-item>
  </el-carousel>
</template>
<script>
import { homeCommonData } from '@/api/frontApi/frontHome';
export default {
  data() {
    return {
      srcArr: [],
      bannerHight: 500,
      homeBannerList: []
    };
  },
  components: {},
  created() {
    this.getBanner();
  },
  methods: {
    getBanner() {
      // banner图片获取
      homeCommonData({ pageNo: 1, pageSize: 100, commonType: 1 }).then(res => {
        res.data.records.forEach(item => {
          let banObj = { path: '', title: '', link: '', active: 0 };
          banObj.path = item.commonImg;
          banObj.title = item.commonId;
          banObj.link = item.commonUrl;
          if (item.commonUrl) banObj.active = 1;
          this.homeBannerList.push(banObj);
        });
      });
    },
    homeBannerLink(bObj) {
      if (bObj.link) window.open(bObj.link);
    }
  }
};
</script>
<style scoped>
.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}
.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
.bn_hand {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/views/home/banner.vue